export const detectDepartmentIntent = (text: string) => {
    const cleaned = text.toLowerCase().trim();

    /** ----------------------------------
     * DELETE: No name
     * ---------------------------------- */
    if (cleaned === "delete department" || cleaned === "remove department") {
        return { intent: "delete_department" };
    }

    /** ----------------------------------
     * DELETE: With name
     * ---------------------------------- */
    const deleteMatch = cleaned.match(/delete (.+) department/);
    if (deleteMatch) {
        return { intent: "delete_department", name: deleteMatch[1].trim() };
    }

    /** ----------------------------------
     * CREATE: Without name
     * ---------------------------------- */
    if (cleaned.includes("create department") || cleaned.includes("add department")) {
        return { intent: "create_department" };
    }

    /** ----------------------------------
     * CREATE: With name
     * ---------------------------------- */
    const createMatch = cleaned.match(/create department named (.+)/);
    if (createMatch) {
        return { intent: "create_department", name: createMatch[1].trim() };
    }

    return null;
};
